import { ReactNode, useEffect } from 'react';
import { Dialog, Typography, PrimaryButton } from '@uni-of-exeter/digital.lib.react.ui.kit';

import './error-dialog.css';

interface DialogProps {
  isOpen: boolean;
  onClose: () => void;
  errorMessage?: string;
  userFacingMessage?: string
}

export const ErrorDialog: React.FC<DialogProps> = ({ isOpen, onClose, errorMessage, userFacingMessage }) => {
  useEffect(() => {
    if (errorMessage) {
      console.error('Error: ', errorMessage);
    }
  }, [errorMessage]);

  useEffect(() => {
    if (isOpen === true) {
      const rootElement = document.getElementById('root');
      if (!rootElement) {
        return;
      }
      rootElement.style.filter = 'blur(4px)';
    }
  }, [isOpen]);

  const close = () => {
    const rootElement = document.getElementById('root');
    if (!rootElement) {
      return;
    }
    rootElement.style.filter = '';
    onClose();
  };

  if (!isOpen) return null;

  const genericMessage = () =>
    <Typography variant="body">
      To resolve the issue, please close this page and reopen the app in a single browser tab.
      If the problem persists, please contact us via our{' '}
      <a
        href="https://forms.office.com/e/q8FqQURVr1"
        target="_blank"
        rel="noopener noreferrer"
      >
        support request form
      </a>
      .
    </Typography>

  const errorMessageText = (errorMessage: string): ReactNode => {
    return <Typography variant="body" style={{ marginTop: '12px' }}>
      {errorMessage}
    </Typography>
  }
  return (
    <Dialog
      open={isOpen}
      onClose={close}
      closable={false}
      footer={
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
          <PrimaryButton
            aria-label={'Close Dialog'}
            aria-hidden={!isOpen}
            label="Close"
            onClick={close}
          />
        </div>
      }
    >
      <div className="custom-dialog-content">
        <div>
          <i className="icon fa-solid fa-triangle-exclamation fa-lg" />
        </div>
        <Typography variant="h4">Something has gone wrong</Typography>
        {userFacingMessage ? errorMessageText(userFacingMessage) : genericMessage()}
      </div>
    </Dialog>
  );
};
